var touchAvailable = require('./touch-available');
function isDesktop() {
    return (!touchAvailable && !window.orientation);
}
module.exports = isDesktop;